import React, { useEffect, useState } from "react";
import { Button, Card } from "@mantine/core";
import AppHeader from "../components/Header/AppHeader";
import {
  sendGridData,
  getComplianceStatus,
  getRecoveryDashboardTable,
  getDashboardData,
  getVPSData,
} from "../utilities/apis/analytics";
import { selectUserData } from "../redux/selectors";
import { useSelector } from "react-redux";
import { apiWrapWithErrorWithData } from "../utilities/apiHelpers"; // Import the necessary functions
import { AgreementManagerAnalytics } from "../utilities/apis/tasks";
import { IconServer, IconMail } from "@tabler/icons-react";
import { useNavigate } from "react-router-dom";

const SystemAnalytics = () => {
  const navigate = useNavigate();
  const userData = useSelector(selectUserData);
  const [formState, setFormState] = useState({
    loading: false,
    tableList: [],
    filter: {
      status: "All",
      searchText: "",
      sortType: "DESC",
      orderByColumn: "",
      minAmount: 0,
      maxAmount: 0,
    },
    pageNo: 1,
    pageSize: "10",
    totalDataCount: 0,
    apiCall: true,
  });

  const payload = {
    filter: formState.filter,
    pageNo: formState.pageNo,
    pageSize: formState.pageSize,
  };

  const [countConfig, setCountConifg] = useState({
    page: 1,
    count: 0,
    pageSize: 10,
  });

  const formatBytes = (bytes, decimals = 2) =>
    `${(bytes / 1e9).toFixed(decimals)} GB`;

  const [filtersForData, setFiltersForData] = useState({
    compliant: null,
    createdAt: null,
    department:
      userData.loginAs.name === "CXO" ||
      userData.loginAs.name === "DeptAdmin" ||
      userData.loginAs.name === "DeptUser"
        ? userData.department
        : null,
    businessUnit:
      userData.loginAs.name === "COO" ? userData.businessUnit : null,
    extraCol1: null,
    mapRegion: null,
  });

  // State to hold metrics data
  const [metricsData, setMetricsData] = useState({
    // agreements: {
    //   title: "Agreements",
    //   icon: IconFileText,
    //   color: "#2563eb",
    //   bgColor: "#eff6ff",
    //   metrics: [],
    // },
    // obligations: {
    //   title: "Obligations",
    //   icon: IconAlertCircle,
    //   color: "#d97706",
    //   bgColor: "#f0ab83ff",
    //   metrics: [],
    // },
    // recovery: {
    //   title: "Recovery",
    //   icon: IconCurrencyDollar,
    //   color: "text-green-600",
    //   bgColor: "#f1da7dff",
    //   metrics: [],
    // },
    infrastructure: {
      title: "Infrastructure",
      icon: IconServer,
      color: "text-purple-600",
      bgColor: "#ffebf7ff",
      metrics: [],
    },
    subscriptions: {
      title: "Subscriptions",
      icon: IconMail,
      color: "text-primary",
      bgColor: "#d3f790ff",
      metrics: [], // Initially empty, will be updated with API data
    },
  });

  // Fetch data and update subscriptions metrics
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await sendGridData();

        const subscriptionsMetrics = [
          {
            label: "Mails Released",
            value: response.data.processedCount,
          },
          {
            label: "Mail Utilization",
            value: `${((response.data.processedCount / 25) * 100).toFixed(2)}%`,
          },
          {
            label: "Envelopes Used",
            value: "10",
          },
          {
            label: "Envelope Utilization",
            value: `28%`,
          },
        ];

        setMetricsData((prevData) => ({
          ...prevData,
          subscriptions: {
            ...prevData.subscriptions,
            metrics: subscriptionsMetrics,
          },
        }));
      } catch (error) {
        console.error("Failed to fetch subscriptions data:", error);
      }
    };

    fetchData();
  }, []);

  // // Fetch agreement analytics data
  // useEffect(() => {
  //   const fetchAgreementAnalytics = async () => {
  //     try {
  //       const resp = await apiWrapWithErrorWithData(
  //         AgreementManagerAnalytics()
  //       );
  //       if (resp?.success && resp?.analytics) {
  //         const analytics = resp.analytics;

  //         // Map analytics data to agreements metrics
  //         const agreementsMetrics = [
  //           {
  //             label: "Total Agreements",
  //             value:
  //               analytics.find((ele) => ele.status === "Total")?.count || 0,
  //           },
  //           {
  //             label: "Review Status",
  //             value:
  //               analytics.find((ele) => ele.status === "Reviewer")?.count || 0,
  //           },
  //           {
  //             label: "Signature Status",
  //             value:
  //               analytics.find((ele) => ele.status === "Sign-Auth")?.count || 0,
  //           },
  //           {
  //             label: "Signed",
  //             value:
  //               analytics.find((ele) => ele.status === "Signed")?.count || 0,
  //           },
  //         ];

  //         // Update the metricsData state
  //         setMetricsData((prevData) => ({
  //           ...prevData,
  //           agreements: {
  //             ...prevData.agreements,
  //             metrics: agreementsMetrics,
  //           },
  //         }));
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch agreement analytics:", error);
  //     }
  //   };

  //   fetchAgreementAnalytics();
  // }, []);

  // // Fetch obligation analytics data
  // useEffect(() => {
  //   const fetchObligationAnalytics = async () => {
  //     try {
  //       const filterdata = Object.fromEntries(
  //         Object.entries(filtersForData).filter(
  //           ([key, value]) => value !== null
  //         )
  //       );
  //       const resp = await getComplianceStatus({
  //         filters: filterdata,
  //         page: countConfig.page,
  //         pageSize: countConfig.pageSize,
  //       });
  //
  //       if (resp?.success) {
  //         // Map analytics data to obligations metrics
  //         const obligationsMetrics = [
  //           { label: "Created", value: resp?.count },
  //           { label: "Updated", value: 0 },
  //         ];

  //         // Update the metricsData state
  //         setMetricsData((prevData) => ({
  //           ...prevData,
  //           obligations: {
  //             ...prevData.obligations,
  //             metrics: obligationsMetrics,
  //           },
  //         }));
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch agreement analytics:", error);
  //     }
  //   };

  //   fetchObligationAnalytics();
  // }, []);

  // // Fetch recovery analytics data
  // useEffect(() => {
  //   const fetchRecoveryAnalytics = async () => {
  //     try {
  //       const filterdata = Object.fromEntries(
  //         Object.entries(filtersForData).filter(
  //           ([key, value]) => value !== null
  //         )
  //       );

  //       const response = await apiWrapWithErrorWithData(getDashboardData({}));
  //       if (response.success && response?.result) {
  //
  //         // setDashboardData((prevState) => ({
  //         //   ...prevState,
  //         //   loading: false,
  //         //   monthlyStats: response.data.monthlyStats,
  //         //   yearlyStats: response.data.yearlyStats,
  //         //   ageingStats: response.data.ageingStats,
  //         // }));
  //       }

  //       const resp = await apiWrapWithErrorWithData(
  //         getRecoveryDashboardTable(payload)
  //       );
  //
  //       if (resp?.success) {
  //
  //         // Map analytics data to recovery metrics
  //         const recoveryMetrics = [
  //           { label: "Created", value: resp.result.data.recoveryList.length },
  //           { label: "Updated", value: 0 },
  //         ];

  //         // Update the metricsData state
  //         setMetricsData((prevData) => ({
  //           ...prevData,
  //           recovery: {
  //             ...prevData.recovery,
  //             metrics: recoveryMetrics,
  //           },
  //         }));
  //       }
  //     } catch (error) {
  //       console.error("Failed to fetch agreement analytics:", error);
  //     }
  //   };

  //   fetchRecoveryAnalytics();
  // }, []);

  // Fetch VPS (Hostinger) analytics data
  // Track updating state and last-updated timestamp for VPS data
  const [vpsUpdating, setVpsUpdating] = useState(false);
  const [vpsLastUpdated, setVpsLastUpdated] = useState(null);

  useEffect(() => {
    let mounted = true;

    const fetchVPSAnalytics = async () => {
      try {
        if (!mounted) return;
        setVpsUpdating(true);

        const resp = await getVPSData();

        if (!mounted) return;
        if (resp?.status === 200) {
          // Extract the usage data for CPU, RAM, and Disk
          const cpuUsage = resp.data.cpu_usage.usage;
          const ramUsage = resp.data.ram_usage.usage;
          const diskUsage = resp.data.disk_space.usage;

          const diskFirstKey = Object.keys(diskUsage)[0];
          const diskLastKey = Object.keys(diskUsage).at(-1);

          // Get the corresponding values
          const diskFirstValue = diskUsage[diskFirstKey];
          const diskLastValue = diskUsage[diskLastKey];

          // Calculate the average and maximum for CPU usage
          const cpuValues = Object.values(cpuUsage);
          const cpuAverage =
            cpuValues.reduce((sum, value) => sum + value, 0) / cpuValues.length;
          const cpuMax = Math.max(...cpuValues);

          // Calculate the average and maximum for RAM usage
          const ramValues = Object.values(ramUsage);
          const ramAverage =
            ramValues.reduce((sum, value) => sum + value, 0) / ramValues.length;
          const ramMax = Math.max(...ramValues);

          // Map analytics data to infrastructure metrics
          const infrastructureMetrics = [
            {
              label: "Memory (Avg)",
              value: `${formatBytes(ramAverage)}`,
              subtext: `Max: ${formatBytes(ramMax)}`,
            },
            {
              label: "CPU (Avg)",
              value: `${cpuAverage.toFixed(2)} %`,
              subtext: `Max: ${cpuMax.toFixed(2)} %`,
            },
            {
              label: "Storage (Server)",
              value: `${formatBytes(diskLastValue)}`,
              subtext: "Utilized",
            },
            { label: "Storage (Server)", value: "200 GB", subtext: "Total" },
          ];

          // Update the metricsData state
          setMetricsData((prevData) => ({
            ...prevData,
            infrastructure: {
              ...prevData.infrastructure,
              metrics: infrastructureMetrics,
            },
          }));

          setVpsLastUpdated(new Date());
        }
      } catch (error) {
        console.error("Failed to fetch VPS analytics:", error);
      } finally {
        if (mounted) setVpsUpdating(false);
      }
    };

    // initial fetch
    fetchVPSAnalytics();
    // poll every 60s
    const id = setInterval(fetchVPSAnalytics, 60000);

    return () => {
      mounted = false;
      clearInterval(id);
    };
  }, []);

  const MetricCard = React.memo(({ metric, index }) => (
    <Card
      key={index}
      shadow="sm"
      padding="md"
      radius="md"
      withBorder
      style={{ transition: "box-shadow 0.2s" }}
    >
      <div
        style={{
          marginBottom: 8,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "flex-start",
        }}
      >
        <span
          style={{
            fontSize: 14,
            fontWeight: 500,
            color: "var(--mantine-color-dimmed)",
          }}
        >
          {metric.label}
        </span>
      </div>
      <div
        style={{
          fontSize: 24,
          fontWeight: 700,
          color: "var(--mantine-color-text)",
        }}
      >
        {metric.value}
      </div>
      {metric.subtext && (
        <span style={{ fontSize: 12, color: "var(--mantine-color-dimmed)" }}>
          {metric.subtext}
        </span>
      )}
    </Card>
  ));

  const CategorySection = React.memo(
    ({ category, data, updating, lastUpdated }) => (
      <Card shadow="md" padding="lg" radius="md" withBorder mb={32}>
        <Card.Section
          inheritPadding
          py="xs"
          style={{
            background: data.bgColor,
            borderRadius: "8px 8px 0 0",
            display: "flex",
            alignItems: "center",
            gap: 12,
          }}
        >
          <div
            style={{
              padding: 8,
              background: "#fff",
              borderRadius: 8,
              color: `var(--mantine-color-${data.color.replace("text-", "")})`,
            }}
          >
            <data.icon style={{ width: 20, height: 20 }} />
          </div>
          <span style={{ fontSize: 18, fontWeight: 600 }}>{data.title}</span>
          <span
            style={{
              fontSize: 14,
              color: "var(--mantine-color-dimmed)",
              marginLeft: "auto",
              display: "flex",
              alignItems: "center",
              gap: 8,
            }}
          >
            <span>{data.metrics.length} metrics</span>
            {updating ? (
              <span
                style={{ fontSize: 12, color: "var(--mantine-color-dimmed)" }}
              >
                Updating...
              </span>
            ) : lastUpdated ? (
              <span
                style={{ fontSize: 12, color: "var(--mantine-color-dimmed)" }}
              >
                Updated: {new Date(lastUpdated).toLocaleTimeString()}
              </span>
            ) : null}
          </span>
        </Card.Section>
        <Card.Section>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
              gap: 16,
              padding: 24,
            }}
          >
            {data.metrics.map((metric, index) => (
              <MetricCard key={index} metric={metric} index={index} />
            ))}
          </div>
        </Card.Section>
      </Card>
    ),
  );

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <AppHeader hide={true} />

      {/* Main Content */}
      <main className="p-6 max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="mb-8">
          <h1 className="text-3xl font-medium text-foreground mb-2">
            Analytics Dashboard
          </h1>
          <p className="text-muted-foreground">
            Comprehensive overview of your legal operations and system
            performance
          </p>
        </div>

        {/* Quick Stats */}
        {/* <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
            gap: 24,
            marginBottom: 32,
          }}
        >
          <Card
            shadow="md"
            padding="lg"
            radius="md"
            withBorder
            style={{
              background:
                "linear-gradient(135deg, var(--mantine-color-primary-light) 10%, var(--mantine-color-primary-light) 5%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 32,
                fontWeight: 700,
                color: "hsla(185, 71%, 45%, 1.00)",
                marginBottom: 8,
              }}
            >
              506
            </div>
            <div style={{ fontSize: 14, color: "var(--mantine-color-dimmed)" }}>
              Total Legal Items
            </div>
          </Card>
          <Card
            shadow="md"
            padding="lg"
            radius="md"
            withBorder
            style={{
              background:
                "linear-gradient(135deg, #22c55e1a 10%, #22c55e0d 5%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 32,
                fontWeight: 700,
                color: "#22c55e",
                marginBottom: 8,
              }}
            >
              94%
            </div>
            <div style={{ fontSize: 14, color: "var(--mantine-color-dimmed)" }}>
              Completion Rate
            </div>
          </Card>
          <Card
            shadow="md"
            padding="lg"
            radius="md"
            withBorder
            style={{
              background:
                "linear-gradient(135deg, #f59e0b1a 10%, #f59e0b0d 5%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 32,
                fontWeight: 700,
                color: "#f59e0b",
                marginBottom: 8,
              }}
            >
              23%
            </div>
            <div style={{ fontSize: 14, color: "var(--mantine-color-dimmed)" }}>
              System Load
            </div>
          </Card>
          <Card
            shadow="md"
            padding="lg"
            radius="md"
            withBorder
            style={{
              background:
                "linear-gradient(135deg, #a78bfa1a 10%, #a78bfa0d 5%)",
              textAlign: "center",
            }}
          >
            <div
              style={{
                fontSize: 32,
                fontWeight: 700,
                color: "#a78bfa",
                marginBottom: 8,
              }}
            >
              72%
            </div>
            <div style={{ fontSize: 14, color: "var(--mantine-color-dimmed)" }}>
              Resource Utilization
            </div>
          </Card>
        </div> */}

        {/* Detailed Metrics by Category */}
        <div className="space-y-6">
          {Object.entries(metricsData).map(([key, data]) => (
            <CategorySection
              key={key}
              category={key}
              data={data}
              updating={key === "infrastructure" ? vpsUpdating : false}
              lastUpdated={key === "infrastructure" ? vpsLastUpdated : null}
            />
          ))}
        </div>
      </main>
    </div>
  );
};

export default SystemAnalytics;
